import React from "react"
import { graphql } from "gatsby"
import CaseStudyTemplate from "../../../components/caseStudies/CaseStudyTemplate"
import data from "../../../data/caseStudies/borjan"

const Borjan = ({ data: queryData }) => (
  <CaseStudyTemplate
    {...data}
    heroImage={queryData.heroImage?.childImageSharp?.gatsbyImageData}
  />
)

export default Borjan

export const query = graphql`
  query BorjanCaseStudyImages {
    heroImage: file(relativePath: { eq: "caseStudies/borjan-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
  }
`
